import React from 'react';
import { 
  Box, 
  Button, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem,
  CircularProgress,
  Tooltip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';

/**
 * Component for campaign filtering options
 */
const CampaignFilters = ({ 
  platformFilter, 
  handlePlatformFilterChange,
  facebookAccountId,
  handleFacebookAccountChange,
  facebookAccounts,
  isFacebookAccountRequired,
  validateFilters,
  handleSearch,
  loading
}) => {
  
  const handleSearchClick = () => {
    const validation = validateFilters();
    if (!validation.isValid) {
      // You could show an alert here, but for now we'll let the parent handle it
      console.warn(validation.error);
    }
    handleSearch(validation);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, height: '100%', alignItems: 'flex-end' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
        <FilterListIcon color="action" fontSize="small" />
        
        {/* Platform Filter */}
        <FormControl size="small" sx={{ minWidth: 110 }}>
          <InputLabel id="platform-filter-label">Platform</InputLabel>
          <Select
            labelId="platform-filter-label"
            id="platform-filter"
            value={platformFilter}
            label="Platform"
            onChange={handlePlatformFilterChange}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="taboola">Taboola</MenuItem>
            <MenuItem value="facebook">Facebook (All Accounts)</MenuItem>
          </Select>
        </FormControl>
        
      </Box>

      <Tooltip title="Search with current filters">
        <Button
          variant="contained"
          onClick={handleSearchClick}
          size="medium"
          disableElevation
          sx={{ 
            minWidth: '100px',
            height: '40px'
          }}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />}
        >
          {loading ? 'Loading...' : 'Search'}
        </Button>
      </Tooltip>
    </Box>
  );
};

export default CampaignFilters; 